// Ideas Modal - Multiple Products Quick Add
document.addEventListener("DOMContentLoaded", function () {
  const modal = document.getElementById("ideas-modal");
  const modalContent = document.getElementById("ideas-modal-content");
  let currentProducts = [];
  let productDataMap = {};
  let currentModalTitle = "";

  function showButtonLoading(button) {
    if (getComputedStyle(button).position === "static") {
      button.style.position = "relative";
    }

    let loadingDots = button.querySelector(".quick-add-loading-dots");
    if (!loadingDots) {
      loadingDots = document.createElement("div");
      loadingDots.className = "quick-add-loading-dots";
      loadingDots.innerHTML = `
        <span class="dot"></span>
        <span class="dot"></span>
        <span class="dot"></span>
      `;
      button.appendChild(loadingDots);
    }

    loadingDots.style.opacity = "1";
    button.classList.add("loading");
    button.querySelector("svg")?.style.setProperty("opacity", "0");
  }

  function restoreButtonText(button) {
    const loadingDots = button.querySelector(".quick-add-loading-dots");
    if (loadingDots) {
      loadingDots.style.opacity = "0";
      setTimeout(() => {
        if (loadingDots.parentNode) {
          loadingDots.remove();
        }
      }, 300);
    }
    button.classList.remove("loading");
    button.querySelector("svg")?.style.setProperty("opacity", "1");
  }

  function showModalLoading() {
    modalContent.innerHTML = `
      <div class="ideas-modal-loading">
        <div class="ideas-loading-dots">
          <span class="dot"></span>
          <span class="dot"></span>
          <span class="dot"></span>
        </div>
      </div>
    `;
  }

  function updateProductIndexInHTML(productHTML, correctIndex) {
    if (!productHTML || correctIndex === undefined || correctIndex === null) {
      return;
    }

    // Update data attribute
    productHTML.dataset.productIndex = correctIndex;

    // Update all radio button IDs and names
    const allRadios = productHTML.querySelectorAll('input[type="radio"]');
    allRadios.forEach((radio) => {
      const oldName = radio.name;
      const oldId = radio.id;

      // Extract option position from old name (format: ideas-option-X-Y)
      const nameMatch = oldName.match(/^ideas-option-(\d+)-(\d+)$/);
      if (nameMatch) {
        const optionPosition = nameMatch[2];

        // Update name with correct product index
        const newName = `ideas-option-${correctIndex}-${optionPosition}`;
        radio.name = newName;

        // Update ID (format: ideas-option-X-Y-Z)
        const idMatch = oldId.match(/^ideas-option-(\d+)-(\d+)-(\d+)$/);
        if (idMatch) {
          const optionPosition = idMatch[2];
          const valueIndex = idMatch[3];
          const newId = `ideas-option-${correctIndex}-${optionPosition}-${valueIndex}`;
          radio.id = newId;

          // Update corresponding label's 'for' attribute
          const label = productHTML.querySelector(`label[for="${oldId}"]`);
          if (label) {
            label.setAttribute("for", newId);
          }
        }
      }
    });

    // Color swatches are already linked via radio IDs, no additional updates needed
  }

  async function fetchProduct(productHandle, index) {
    try {
      const response = await fetch(
        `/products/${productHandle}?section_id=ideas-modal-product&product_handle=${productHandle}&product_index=${index}`
      );
      if (!response.ok) throw new Error("Failed to fetch product");

      const text = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(text, "text/html");
      const productHTML = doc.querySelector(".ideas-modal-product");

      if (!productHTML) throw new Error("Invalid product content");

      // Update all IDs and names to use the correct product index
      // This ensures uniqueness even if server-side parameter wasn't read correctly
      updateProductIndexInHTML(productHTML, index);

      // Store product variants data
      const variantsData = productHTML.dataset.productVariants;
      if (variantsData) {
        productDataMap[productHandle] = JSON.parse(variantsData);
      }

      return productHTML;
    } catch (error) {
      console.error(`Error fetching product ${productHandle}:`, error);
      return null;
    }
  }

  async function openIdeasModal(productHandles, button) {
    if (!productHandles || productHandles.length === 0) return;

    currentProducts = productHandles;
    productDataMap = {};

    // Get title and subtitle from button data attributes
    const modalTitle = button?.dataset?.modalTitle || "";
    const modalSubtitle = button?.dataset?.modalSubtitle || "";
    currentModalTitle = modalTitle; // Store for later updates

    // Show loading in button
    if (button) {
      showButtonLoading(button);
    }

    // Open modal
    modal.classList.add("open");
    document.body.style.overflow = "hidden";

    // Check if cart drawer is open
    const cartDrawer = document.getElementById("CartDrawer");
    const isCartOpen = cartDrawer && cartDrawer.classList.contains("open");

    // Set overlay z-index
    const mainOverlay = document.querySelector(".main__overlay");
    if (mainOverlay && window.setOverlayZIndex && window.Z_INDEX) {
      mainOverlay.classList.add("active");
      if (isCartOpen) {
        window.setOverlayZIndex(window.Z_INDEX.OVERLAY_QUICK_ADD_ABOVE_CART);
      } else {
        window.setOverlayZIndex(window.Z_INDEX.OVERLAY_QUICK_ADD);
      }
    }

    // Set active component
    if (window.activeComponent !== undefined) {
      window.activeComponent = "quick-add";
    }

    // Show loading
    showModalLoading();

    // Fetch all products
    const productElements = [];
    for (let i = 0; i < productHandles.length; i++) {
      const productHTML = await fetchProduct(productHandles[i], i);
      if (productHTML) {
        productElements.push(productHTML);
      }
    }

    // Calculate initial discount for title
    let initialDiscount = 0;
    let initialTotalPrice = 0;
    let initialComparePrice = 0;

    productElements.forEach((productEl) => {
      const productHandle = productEl.dataset.productHandle;
      const variantInput = productEl.querySelector(".ideas-product-variant-id");
      if (variantInput && variantInput.value) {
        // Use productDataMap if available, otherwise parse from data attribute
        let variant = null;
        if (productDataMap[productHandle]) {
          variant = productDataMap[productHandle].find(
            (v) => v.id === parseInt(variantInput.value)
          );
        } else {
          // Fallback: parse from data attribute
          const variantsData = productEl.dataset.productVariants;
          if (variantsData) {
            try {
              const variants = JSON.parse(variantsData);
              variant = variants.find(
                (v) => v.id === parseInt(variantInput.value)
              );
            } catch (e) {
              console.error("Error parsing variants:", e);
            }
          }
        }

        if (variant) {
          initialTotalPrice += variant.price;
          if (
            variant.compare_at_price &&
            variant.compare_at_price > variant.price
          ) {
            initialComparePrice += variant.compare_at_price;
          } else {
            initialComparePrice += variant.price;
          }
        }
      }
    });

    initialDiscount = Math.max(0, initialComparePrice - initialTotalPrice);
    const productCount = productElements.length;
    const discountFormatted = Shopify.formatMoney(
      initialDiscount,
      window.money_without_trailing_zeros_format || window.money_format
    );

    // Build title and subtitle HTML only if they exist
    const titleHTML = modalTitle
      ? `<h2 class="ideas-modal-title">${modalTitle}</h2>`
      : "";
    const subtitleHTML = modalSubtitle
      ? `<p class="ideas-modal-subtitle">${modalSubtitle}</p>`
      : "";

    // Render products
    modalContent.innerHTML = `
    <button class="ideas-modal-header__close" aria-label="Close ideas modal">
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" class="icon icon-close" viewBox="0 0 18 17">
        <path fill="currentColor" d="M.865 15.978a.5.5 0 0 0 .707.707l7.433-7.431 7.579 7.282a.501.501 0 0 0 .846-.37.5.5 0 0 0-.153-.351L9.712 8.546l7.417-7.416a.5.5 0 1 0-.707-.708L8.991 7.853 1.413.573a.5.5 0 1 0-.693.72l7.563 7.268z" />
      </svg>
    </button>
      <div class="ideas-modal-header">
        <div class="ideas-modal-header__content">
          <div class="ideas-modal-title-section">
            ${titleHTML}
            ${subtitleHTML}
          </div>
        </div>
      </div>
      <div class="ideas-modal-products-grid">
        ${productElements.map((el) => el.outerHTML).join("")}
      </div>
      <div class="ideas-modal-footer">
        <div class="ideas-modal-totals">
          <div class="ideas-modal-total-row">
            <span class="ideas-modal-total-label">${window.total}:</span>
            <span class="ideas-modal-total-price">$0.00</span>
          </div>
          <div class="ideas-modal-total-row ideas-modal-compare-total" style="display: none;">
            <span class="ideas-modal-total-label">${window.insteadOf}:</span>
            <span class="ideas-modal-compare-price">$0.00</span>
          </div>
        </div>
        <button class="ideas-modal-add-all-btn cta_btn-full button-hover" type="button">
          <span class="ideas-add-all-text">${window.addToCart}</span>
        </button>
      </div>
    `;

    // Restore button text
    if (button) {
      restoreButtonText(button);
    }

    // Initialize variant selection for each product (query DOM after innerHTML is set)
    const productsGrid = modalContent.querySelector(
      ".ideas-modal-products-grid"
    );
    if (productsGrid) {
      const productContainers = productsGrid.querySelectorAll(
        ".ideas-modal-product"
      );
      productContainers.forEach((productContainer, domIndex) => {
        // Verify container is valid
        if (!productContainer || !productContainer.isConnected) return;

        const productHandle = productContainer.dataset.productHandle;
        const productIndex = parseInt(productContainer.dataset.productIndex);

        // Validate productIndex - must be a valid number
        if (isNaN(productIndex)) {
          console.error(
            "Invalid productIndex for product:",
            productHandle,
            "using domIndex:",
            domIndex
          );
          return;
        }

        // Verify productHandle exists
        if (!productHandle) {
          console.error(
            "Missing productHandle for container at index:",
            domIndex
          );
          return;
        }

        initVariantSelection(productContainer, productHandle, productIndex);
      });
    }

    // Initialize add all button
    initAddAllButton();

    // Calculate initial total
    updateTotalPrice();

    // Check initial button state
    updateAddAllButtonState();
  }

  function closeIdeasModal() {
    modal.classList.remove("open");
    currentProducts = [];
    productDataMap = {};
    currentModalTitle = "";

    const mainOverlay = document.querySelector(".main__overlay");
    const cartDrawer = document.getElementById("CartDrawer");
    const isCartOpen = cartDrawer && cartDrawer.classList.contains("open");

    const searchPopup = document.querySelector(".header__search-popup");
    const isSearchOpen =
      searchPopup && searchPopup.classList.contains("active");

    if (mainOverlay && window.setOverlayZIndex && window.Z_INDEX) {
      if (isCartOpen) {
        mainOverlay.classList.add("active");
        window.setOverlayZIndex(window.Z_INDEX.OVERLAY_CART_DRAWER);
      } else if (isSearchOpen) {
        mainOverlay.classList.add("active");
        window.resetOverlayZIndex();
      } else {
        mainOverlay.classList.remove("active");
        window.resetOverlayZIndex();
      }
    }

    if (window.activeComponent === "quick-add") {
      if (isCartOpen) {
        window.activeComponent = "cart";
      } else {
        window.activeComponent = null;
      }
    }

    if (!isCartOpen) {
      document.body.style.overflow = "";
    }
  }

  function getSelectedOptions(container, productIndex) {
    const selectedOptions = [];

    // Validate productIndex
    if (productIndex === undefined || productIndex === null) {
      return selectedOptions;
    }

    // Query only radios within this container with the correct productIndex
    const allRadios = container.querySelectorAll(
      `input[type="radio"][name^="ideas-option-${productIndex}-"]:checked`
    );

    const optionsMap = new Map();
    allRadios.forEach((radio) => {
      // Double-check radio belongs to this container
      if (!container.contains(radio)) return;

      const nameParts = radio.name.split("-");
      const optionPosition = parseInt(nameParts[nameParts.length - 1]);

      // Verify the name matches the expected pattern
      if (radio.name.startsWith(`ideas-option-${productIndex}-`)) {
        optionsMap.set(optionPosition, radio.value);
      }
    });

    const maxPosition = Math.max(...Array.from(optionsMap.keys()), 0);
    for (let i = 1; i <= maxPosition; i++) {
      selectedOptions.push(optionsMap.get(i) || null);
    }

    return selectedOptions;
  }

  function findVariantByOptions(productHandle, options) {
    const productData = productDataMap[productHandle];
    if (!productData) return null;
    return productData.find((variant) => {
      return variant.options.every(
        (opt, idx) => !options[idx] || options[idx] === opt
      );
    });
  }

  function updateVariantSelection(container, productHandle, productIndex) {
    // Validate container and productIndex
    if (!container || productIndex === undefined || productIndex === null) {
      return;
    }

    // Verify container is still in DOM
    if (!container.isConnected) {
      return;
    }

    const selectedOptions = getSelectedOptions(container, productIndex);
    const selectedVariant = findVariantByOptions(
      productHandle,
      selectedOptions
    );

    if (!selectedVariant) return;

    // Store availability status on container for later checking
    container.dataset.variantAvailable = selectedVariant.available
      ? "true"
      : "false";
    container.dataset.variantTitle = selectedVariant.title || "";

    // Query elements only within this container
    const variantInput = container.querySelector(".ideas-product-variant-id");
    const currentPriceEl = container.querySelector(".current-price");
    const comparePriceEl = container.querySelector(".compare-price");
    const savingsEl = container.querySelector(".savings .save-discount");

    // Verify elements belong to container before updating
    if (variantInput && container.contains(variantInput)) {
      variantInput.value = selectedVariant.id;
    }

    // Update price - verify element belongs to container
    if (currentPriceEl && container.contains(currentPriceEl)) {
      currentPriceEl.textContent = Shopify.formatMoney(
        selectedVariant.price,
        window.money_without_trailing_zeros_format || window.money_format
      );
    }

    if (
      comparePriceEl &&
      savingsEl &&
      container.contains(comparePriceEl) &&
      container.contains(savingsEl)
    ) {
      if (selectedVariant.compare_at_price > selectedVariant.price) {
        comparePriceEl.textContent = Shopify.formatMoney(
          selectedVariant.compare_at_price,
          window.money_without_trailing_zeros_format || window.money_format
        );
        comparePriceEl.style.display = "inline";
        const saveValue =
          100 -
          (selectedVariant.price / selectedVariant.compare_at_price) * 100;
        savingsEl.textContent = `-${Math.ceil(saveValue)}%`;
        const savingsContainer = savingsEl.closest(".savings");
        if (savingsContainer && container.contains(savingsContainer)) {
          savingsContainer.style.display = "inline";
        }
        if (currentPriceEl && container.contains(currentPriceEl)) {
          currentPriceEl.classList.add("red");
        }
      } else {
        comparePriceEl.style.display = "none";
        const savingsContainer = savingsEl.closest(".savings");
        if (savingsContainer && container.contains(savingsContainer)) {
          savingsContainer.style.display = "none";
        }
        if (currentPriceEl && container.contains(currentPriceEl)) {
          currentPriceEl.classList.remove("red");
        }
      }
    }
  }

  function initVariantSelection(container, productHandle, productIndex) {
    // Validate productIndex
    if (productIndex === undefined || productIndex === null) {
      console.error("Invalid productIndex for product:", productHandle);
      return;
    }

    // Query only within this specific container
    const colorSwatches = container.querySelectorAll(".quick-add-color-option");
    const variantRadios = container.querySelectorAll(
      '.variant-option input[type="radio"]'
    );

    // Color swatch clicks - fully scoped to this container
    colorSwatches.forEach((swatch) => {
      // Verify swatch belongs to this container
      if (!container.contains(swatch)) return;

      swatch.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();

        // Double-check swatch belongs to this container
        if (!container.contains(swatch)) return;

        const optionPosition = swatch.dataset.optionPosition;
        const value = swatch.dataset.value;

        // Query radio within this container only
        const radio = container.querySelector(
          `input[name="ideas-option-${productIndex}-${optionPosition}"][value="${CSS.escape(
            value
          )}"]`
        );

        // Verify radio belongs to this container and name matches productIndex
        if (
          !radio ||
          !container.contains(radio) ||
          radio.disabled ||
          !radio.name.startsWith(`ideas-option-${productIndex}-`)
        ) {
          return;
        }

        // Update swatches only within this product's color group
        const colorsContainer = swatch.closest(".quick-add-colors");
        if (colorsContainer && container.contains(colorsContainer)) {
          colorsContainer
            .querySelectorAll(".quick-add-color-option")
            .forEach((btn) => {
              if (container.contains(btn)) {
                btn.setAttribute("aria-current", "false");
                btn.classList.remove("selected");
              }
            });
        }
        swatch.setAttribute("aria-current", "true");
        swatch.classList.add("selected");

        // Update fieldset only within this container
        const fieldset = swatch.closest(".variant-option");
        if (fieldset && container.contains(fieldset)) {
          const selectedValueSpan = fieldset.querySelector(
            "legend .selected-value"
          );
          if (selectedValueSpan) {
            selectedValueSpan.textContent = value;
          }
        }

        radio.checked = true;
        // Dispatch change event without bubbling to prevent cross-product interference
        const changeEvent = new Event("change", { bubbles: false });
        radio.dispatchEvent(changeEvent);

        updateVariantSelection(container, productHandle, productIndex);
        updateTotalPrice();
        updateAddAllButtonState();
      });
    });

    // Regular radio changes - fully scoped to this container
    variantRadios.forEach((radio) => {
      // Verify radio belongs to this container
      if (!container.contains(radio)) return;

      // Verify radio name matches this productIndex
      if (!radio.name.startsWith(`ideas-option-${productIndex}-`)) {
        return;
      }

      radio.addEventListener("change", function (e) {
        // Ensure this radio belongs to our container
        if (!container.contains(radio)) return;

        // Double-check radio name matches this productIndex
        if (!radio.name.startsWith(`ideas-option-${productIndex}-`)) {
          return;
        }

        e.stopPropagation();
        e.stopImmediatePropagation();

        const fieldset = radio.closest(".variant-option");
        if (fieldset && container.contains(fieldset)) {
          const labels = fieldset.querySelectorAll(".option-value");
          labels.forEach((label) => {
            if (container.contains(label)) {
              label.classList.remove("selected");
            }
          });
          const checkedLabel = fieldset.querySelector(
            `label[for="${radio.id}"]`
          );
          if (checkedLabel && container.contains(checkedLabel)) {
            checkedLabel.classList.add("selected");
          }

          const selectedValueSpan = fieldset.querySelector(
            "legend .selected-value"
          );
          if (selectedValueSpan) {
            selectedValueSpan.textContent = radio.value;
          }
        }

        updateVariantSelection(container, productHandle, productIndex);
        updateTotalPrice();
        updateAddAllButtonState();
      });
    });

    // Initialize selected state
    updateVariantSelection(container, productHandle, productIndex);
    updateTotalPrice();
    updateAddAllButtonState();
  }

  function updateTotalPrice() {
    const productContainers = modalContent.querySelectorAll(
      ".ideas-modal-product"
    );
    let totalPrice = 0;
    let totalComparePrice = 0;
    let hasComparePrice = false;

    productContainers.forEach((container) => {
      const variantInput = container.querySelector(".ideas-product-variant-id");
      if (!variantInput || !variantInput.value) return;

      const productHandle = container.dataset.productHandle;
      const productData = productDataMap[productHandle];
      if (!productData) return;

      const variant = productData.find(
        (v) => v.id === parseInt(variantInput.value)
      );
      if (!variant) return;

      totalPrice += variant.price;
      if (
        variant.compare_at_price &&
        variant.compare_at_price > variant.price
      ) {
        totalComparePrice += variant.compare_at_price;
        hasComparePrice = true;
      } else {
        totalComparePrice += variant.price;
      }
    });

    const totalPriceEl = modalContent.querySelector(".ideas-modal-total-price");
    const comparePriceEl = modalContent.querySelector(
      ".ideas-modal-compare-price"
    );
    const compareTotalRow = modalContent.querySelector(
      ".ideas-modal-compare-total"
    );

    if (totalPriceEl) {
      totalPriceEl.textContent = Shopify.formatMoney(
        totalPrice,
        window.money_without_trailing_zeros_format || window.money_format
      );
    }

    if (comparePriceEl && compareTotalRow) {
      if (hasComparePrice && totalComparePrice > totalPrice) {
        comparePriceEl.textContent = Shopify.formatMoney(
          totalComparePrice,
          window.money_without_trailing_zeros_format || window.money_format
        );
        compareTotalRow.style.display = "flex";
      } else {
        compareTotalRow.style.display = "none";
      }
    }

    // Update title with current discount (only if no custom title was provided)
    if (!currentModalTitle) {
      const titleEl = modalContent.querySelector(".ideas-modal-title");
      if (titleEl) {
        const productCount = productContainers.length;
        const discount = Math.max(0, totalComparePrice - totalPrice);
        const discountFormatted = Shopify.formatMoney(
          discount,
          window.money_without_trailing_zeros_format || window.money_format
        );
        titleEl.textContent = `Get ${productCount} ${
          productCount === 1 ? "Product" : "Products"
        } with ${discountFormatted} Discount`;
      }
    }
  }

  function updateAddAllButtonState() {
    const addAllBtn = modalContent.querySelector(".ideas-modal-add-all-btn");
    const textElement = addAllBtn?.querySelector(".ideas-add-all-text");
    const messageArea = modalContent.querySelector(
      ".ideas-modal-out-of-stock-message"
    );

    if (!addAllBtn) return;

    // Check all products for sold-out variants
    const productContainers = modalContent.querySelectorAll(
      ".ideas-modal-product"
    );
    const outOfStockProducts = [];

    productContainers.forEach((container) => {
      const productHandle = container.dataset.productHandle;
      const variantAvailable = container.dataset.variantAvailable;
      const variantTitle = container.dataset.variantTitle || "";
      const productTitle =
        container
          .querySelector(".ideas-modal-product__title")
          ?.textContent?.trim() || "";
      const variantInput = container.querySelector(".ideas-product-variant-id");

      // Check if variant is selected and if it's available
      if (variantInput && variantInput.value) {
        if (variantAvailable === "false") {
          outOfStockProducts.push({
            productTitle: productTitle,
            variantTitle: variantTitle,
            productHandle: productHandle,
          });
        }
      }
    });

    // Update button state
    if (outOfStockProducts.length > 0) {
      // Sold out state
      addAllBtn.disabled = true;
      addAllBtn.style.opacity = "0.5";
      addAllBtn.style.cursor = "not-allowed";

      if (textElement) {
        textElement.textContent = window.soldOutText;
      }

      // Show out-of-stock message
      if (!messageArea) {
        const newMessageArea = document.createElement("div");
        newMessageArea.className = "ideas-modal-out-of-stock-message";
        const totalsDiv = modalContent.querySelector(".ideas-modal-totals");
        if (totalsDiv) {
          totalsDiv.insertAdjacentElement("afterend", newMessageArea);
        }
      }

      const finalMessageArea = modalContent.querySelector(
        ".ideas-modal-out-of-stock-message"
      );
      if (finalMessageArea) {
        const messages = outOfStockProducts.map((item) => {
          const variantInfo = item.variantTitle
            ? ` (${item.variantTitle})`
            : "";
          return `${item.productTitle}${variantInfo}`;
        });
        finalMessageArea.innerHTML = `<div class="ideas-out-of-stock-text">${messages.join(
          ", "
        )} ${messages.length === 1 ? "is" : "are"} out of stock</div>`;
        finalMessageArea.style.display = "block";
      }
    } else {
      // Available state
      addAllBtn.disabled = false;
      addAllBtn.style.opacity = "1";
      addAllBtn.style.cursor = "pointer";

      if (textElement) {
        textElement.textContent = window.addToCart;
      }

      // Hide out-of-stock message
      if (messageArea) {
        messageArea.style.display = "none";
      }
    }
  }

  function initAddAllButton() {
    const addAllBtn = modalContent.querySelector(".ideas-modal-add-all-btn");
    if (!addAllBtn) return;

    addAllBtn.addEventListener("click", async () => {
      const productContainers = modalContent.querySelectorAll(
        ".ideas-modal-product"
      );
      const items = [];

      productContainers.forEach((container) => {
        const variantInput = container.querySelector(
          ".ideas-product-variant-id"
        );
        if (variantInput && variantInput.value) {
          items.push({
            id: parseInt(variantInput.value),
            quantity: 1,
          });
        }
      });

      if (items.length === 0) return;

      // Store original text
      const originalText = addAllBtn.textContent;
      const textElement = addAllBtn.querySelector(".ideas-add-all-text");

      // Show loading dots (overlay, don't remove text)
      addAllBtn.disabled = true;
      if (getComputedStyle(addAllBtn).position === "static") {
        addAllBtn.style.position = "relative";
      }

      let loadingDots = addAllBtn.querySelector(".ideas-loading-dots");
      if (!loadingDots) {
        loadingDots = document.createElement("div");
        loadingDots.className = "ideas-loading-dots";
        loadingDots.innerHTML = `
          <span class="dot"></span>
          <span class="dot"></span>
          <span class="dot"></span>
        `;
        addAllBtn.appendChild(loadingDots);
      }
      loadingDots.style.opacity = "1";

      // Hide text while loading
      if (textElement) {
        textElement.style.opacity = "0";
      } else {
        addAllBtn.style.color = "transparent";
      }

      try {
        const cartUrl = window.routes.cart_add_url + ".js";
        const response = await fetch(cartUrl, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ items }),
        });

        const data = await response.json();

        if (response.ok) {
          // Publish cart update event (same as quick-add.js)
          publish(PUB_SUB_EVENTS.cartUpdate, {
            action: "add",
            items: data.items,
          });

          // Hide loading dots
          loadingDots.style.opacity = "0";

          // Show success text
          if (textElement) {
            textElement.textContent = window.added;
            textElement.style.opacity = "1";
          } else {
            addAllBtn.textContent = window.added;
            addAllBtn.style.color = "";
          }

          setTimeout(() => {
            closeIdeasModal();
          }, 1000);
        } else {
          throw new Error(data.description || "Failed to add to cart");
        }
      } catch (error) {
        console.error("Error adding to cart:", error);

        // Publish error event (same as quick-add.js)
        publish(PUB_SUB_EVENTS.cartError, {
          error: error.message,
          context: "ideas-modal",
        });

        // Hide loading dots
        loadingDots.style.opacity = "0";

        // Show error text
        if (textElement) {
          textElement.textContent = "Error";
          textElement.style.opacity = "1";
        } else {
          addAllBtn.textContent = "Error";
          addAllBtn.style.color = "";
        }

        setTimeout(() => {
          // Restore original text
          if (textElement) {
            textElement.textContent = originalText;
            textElement.style.opacity = "1";
          } else {
            addAllBtn.textContent = originalText;
            addAllBtn.style.color = "";
          }
          addAllBtn.disabled = false;
          if (loadingDots) {
            loadingDots.remove();
          }
        }, 2000);
      }
    });
  }

  // Event listeners
  document.addEventListener("click", (e) => {
    // Check if click is on the whole card (but not on the button itself to avoid double trigger)
    const ideaItem = e.target.closest(".home-ideas__item--clickable");
    const quickAddBtn = e.target.closest(".home-ideas__quick-add-btn");

    // If clicked on the button, use button's data
    if (quickAddBtn) {
      e.preventDefault();
      e.stopPropagation();
      const productsStr = quickAddBtn.dataset.products;
      if (productsStr) {
        const productHandles = productsStr.split(",").filter((h) => h.trim());
        openIdeasModal(productHandles, quickAddBtn);
      }
    }
    // If clicked on the card (but not the button), use card's data
    else if (ideaItem) {
      e.preventDefault();
      const productsStr = ideaItem.dataset.products;
      if (productsStr) {
        const productHandles = productsStr.split(",").filter((h) => h.trim());
        // Create a temporary button element for the loading state
        const tempBtn =
          ideaItem.querySelector(".home-ideas__quick-add-btn") || ideaItem;
        openIdeasModal(productHandles, tempBtn);
      }
    }

    if (e.target.closest(".ideas-modal-header__close")) {
      closeIdeasModal();
    }
  });

  const overlay = modal?.querySelector(".ideas-modal__overlay");
  if (overlay) {
    overlay.addEventListener("click", () => {
      closeIdeasModal();
    });
  }

  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && modal.classList.contains("open")) {
      closeIdeasModal();
    }
  });

  // Expose for global access
  window.ideasModal = {
    open: openIdeasModal,
    close: closeIdeasModal,
  };
});
